import { Epic, ofType } from "redux-observable";
import { Observable } from "rxjs";
import { exhaustMap } from "rxjs/operators";
import { CaptchaRepository } from "../../../repositories/captcha.repository";
import { RootState } from "../../reducers";
import { CaptchaActions } from "../actions";
import { LoadCaptcha } from "../actions/default";
import { LOAD_CAPTCHA } from "../constants";

export const loadCaptchaEpic: Epic<
    CaptchaActions,
    CaptchaActions,
    RootState
> = (action$: Observable<CaptchaActions>) =>
    action$.pipe(
        ofType(LOAD_CAPTCHA),
        exhaustMap((action) =>
            CaptchaRepository.validateCaptcha(action as LoadCaptcha)
        )
    );
